module.exports = __webpack_public_path__ + "img/extlink.856ac39f.svg";